
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import { AnalyticsEvent } from 'utils/analytics'
import { CopyGalleryLink } from 'components/pages/Gallery/common/CopyGalleryLink/CopyGalleryLink.module'
import { MUIButton } from 'components/common/MUIButton'
import { PageActions } from 'components/common/Page/PageActions'
import React, { useCallback } from 'react'
import { useClientProperty } from '../../ClientProperty/_main/contexts'
import { useStartOrderForProperty } from '../../ClientProperty/_main/useStartOrderForProperty'
import { useTranslation } from 'react-i18next'
import { useCanUserOrder } from 'utils/user/canUserOrder'

interface Props {
  /** Property ID */
  propertyId?: string
}

export const PropertyPageActions: React.FC<Props> = ({ propertyId }) => {
  const { t } = useTranslation(['property', 'purchase_flow_revamp'])
  const { handleClickOnEmptyAction } = useClientProperty()
  const canUserOrder = useCanUserOrder()
  const { startOrder, completionDrawer } = useStartOrderForProperty()

  const handleCreateOrder = useCallback(() => {
    handleClickOnEmptyAction(AnalyticsEvent.PROPERTY_ORDER_VISUALS_OVERVIEW_HEADER_CLICKED)
    startOrder()
  }, [handleClickOnEmptyAction, startOrder])

  return (
    <PageActions key={`property-page-actions-${propertyId}`}>
      <CopyGalleryLink propertyId={propertyId} />

      {canUserOrder && (
        <MUIButton
          onClick={handleCreateOrder}
          startIcon={<AddCircleOutlineOutlinedIcon fontSize="large" />}
        >{t('add_new_assignment')}
        </MUIButton>
      )}

      {completionDrawer}

    </PageActions>
  )
}
